export enum ProcessDurationScheduledActionType {
  PmApproval = 10,
  PmApprovalDescription = 'PM approval reminder',
  HrApproval = 20,
  HrApprovalDescription = 'HR approval reminder',
  AppraiseeAction = 30,
  AppraiseeActionDescription = 'Appraisee action reminder',
  RespondentAction = 40,
  RespondentActionDescription = 'Respondent action reminder',
}